import React, { useState } from 'react'
import { Link, navigate } from 'gatsby'
import { Icon } from '@chakra-ui/icons'
import { Image } from '@chakra-ui/react'
import { FaHospital, FaHouse } from 'react-icons/fa6'
import { BiLogIn, BiLogOut } from 'react-icons/bi'
import { Box, Text, Flex } from '@chakra-ui/react'

import Logo from '~images/logo/logo.svg'
import { UserRoutes } from '~config/routes'
import SidebarItem from '../sidebar/sidebar-item'
import { SidebarContent } from '../sidebar/sidebar'
import SidebarSettingsMenu from '../sidebar/sidebar-settings-menu'
import { useClinic } from '~contexts/clinic-context'
import { useUserContext } from '~config/user-context'
import SidebarItemIcon from '../sidebar/sidebar-item/icon'
import { useLocation } from '@reach/router'
import { getIsActive } from '../sidebar/sidebar-item/helpers'
import { useLocalStorage } from '~utils/hooks/use-local-storage'
import { LocalStorageKeys } from '~config/constants'

export default function MobileSidebar() {
    const { clinic } = useClinic()
    const { pathname } = useLocation()
    const [submenu, setSubmenu] = useState<string>('none')
    const [useLegacySidebar, setUseLegacySidebar] = useLocalStorage<boolean>(
        LocalStorageKeys.useLegacySidebar,
        false,
    )
    const isActive = getIsActive(UserRoutes.Home, pathname)

    return (
        <Flex
            h="100dvh"
            flexDir="column"
            bg="gray.900"
            justifyContent="space-between"
        >
            <Flex
                py={4}
                pl={4}
                pr={2}
                flexDir="row"
                alignItems="center"
                justifyContent="space-between"
            >
                <Box>
                    <Image
                        src={Logo}
                        alt="Checkvet Logo"
                        borderWidth={1}
                        borderColor="black"
                        h="32px"
                        w="auto"
                        objectFit="contain"
                    />
                </Box>
                <Flex align="center" gap={1}>
                    <SidebarSettingsMenu
                        useLegacySidebar={useLegacySidebar}
                        setUseLegacySidebar={setUseLegacySidebar}
                    />
                    <Link to={UserRoutes.Home}>
                        <Box
                            borderWidth={1}
                            rounded="lg"
                            borderColor="transparent"
                            _hover={{
                                borderColor: 'gray.700',
                                bg: 'gray.800',
                            }}
                        >
                            <SidebarItemIcon
                                isActive={isActive}
                                icon={FaHouse}
                                badgeCount={undefined}
                            />
                        </Box>
                    </Link>
                </Flex>
            </Flex>
            <Box h="full" overflow="auto" px={2}>
                {clinic && (
                    <SidebarItem
                        icon={FaHospital}
                        to={UserRoutes.SelectClinic}
                        label={'Switch Clinic'}
                        submenu={submenu}
                        setSubmenu={setSubmenu}
                    />
                )}
                <SidebarContent
                    submenu={submenu}
                    setSubmenu={setSubmenu}
                    useLegacySidebar={useLegacySidebar}
                />
            </Box>
            <AuthButton />
        </Flex>
    )
}

function AuthButton() {
    const { user, signOut } = useUserContext()

    return (
        <Flex
            w="100%"
            position="relative"
            textAlign={'left'}
            px={3}
            py={3}
            align="center"
            justify="flex-start"
            cursor="pointer"
            transition="all 0.2s"
            bg="gray.800"
            onClick={() => {
                if (user) {
                    signOut()
                } else {
                    navigate(UserRoutes.Auth)
                }
            }}
        >
            <Flex
                minW={8}
                boxSize={8}
                justify="center"
                align="center"
                ml={1}
                mr={2}
            >
                <Icon
                    as={user ? BiLogOut : BiLogIn}
                    boxSize="20px"
                    color={user ? 'red.400' : 'brand.500'}
                />
            </Flex>
            <Text color={user ? 'red.400' : 'brand.500'}>
                {user ? 'Sign Out' : 'Sign In'}
            </Text>
        </Flex>
    )
}
